import { STORE_URLS } from "../../shared/acquisition";

export const APP_STORE_URL = STORE_URLS.ios;
export const PLAY_STORE_URL = STORE_URLS.android;
